import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["children", "jss", "className"];
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Section from "../Layout/Section";
import Row from "../Layout/Row";
import createStyles from "../createStyles";
var useStyles = createStyles(function (theme) {
  return {
    section: _defineProperty({
      padding: theme.spacer(0, 4, 6)
    }, theme.breakpoints.create('sm'), {
      padding: theme.spacer(0, 8, 6, 6)
    })
  };
}, {
  name: 'DialogFooter'
});

var DialogFooter = function DialogFooter(_ref) {
  var children = _ref.children,
      jss = _ref.jss,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles({
    jss: jss
  });
  return /*#__PURE__*/React.createElement(Section, _extends({
    className: classNames(className, classes.section)
  }, props, {
    "data-qa": "dialog-footer"
  }), /*#__PURE__*/React.createElement(Row, {
    spacing: 3,
    align: "center",
    justify: "end",
    fullWidth: true,
    wrap: false
  }, children));
};

DialogFooter.propTypes = {
  /** Child elements to render in header */
  children: PropTypes.node.isRequired
};
export default DialogFooter;